import React from 'react'
import { ScreenContainer } from './App'


export const About = () => {


    return(<>
    <ScreenContainer title="About Us" bgColor='bg-pink-400'>
        <div className='grid p-10'>
        

         <p className='h1 fs-bold text-left px-10'>   </p>
        <p className='p-10 fs-5'>
        Honored to have you here. My name is Dr. Adam Solomon, and I have lost my grandpa way too early to stroke without hearing his last words. 
        We couldn't afford paying $5000 for an eye tracker at the time and that just devastated us. Fast forward 20 years later, I made this device so 
        no one has to go through the pain of watching their loved one struggle to express themselves.

This venture is near and dear to my heart through a journey of utter care and memories.




            <br/>
            <br/>
            
            I truly believe this will bring a smile to you and your loved one as well.


            <br/><br/> Warm regards,
Adam

           
        </p>
        
       
    
        
    
    
        </div>
        </ScreenContainer>
        </>)
}